'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CamelToKebab = function CamelToKebab() {
  return function (input, param) {
    if (angular.isDefined(input)) {
      return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
  };
};
exports.default = CamelToKebab;


// WEBPACK FOOTER //
// ./client/app/common/filters/camelToKebabService/camelToKebab.filter.js